import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { FieldArray, reduxForm } from 'redux-form';
import * as valid from 'utils/validate';
import { lockPermissionsActions, apiCallFailure } from 'app/actions';
import { DAY_TIME_HM } from 'app/constants';
import { api, apiUtils } from 'app/services';
import {
KBPopover,
KBUserInput,
KBFormError,
KBButton,
KBDateInput,
KBSelect } from
'components';
import dayjs from 'utils/dayjs';
import { Select, Spin } from 'antd';
import { debounce } from 'lodash';
import { toKBArrayField } from 'components/formAdapters/reduxFormAdapters';
const { Option } = Select;

var LockPermissionsForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.createLockForm = this.createLockForm.bind(this);this.changeYMD = this.changeYMD.bind(this);this.changeHM = this.changeHM.bind(this);this.searchUser = this.searchUser.bind(this);this.renderLockPermissions = this.renderLockPermissions.bind(this);this.debouncedSearchUser = debounce(this.searchUser, 500);}getInitialState()
  {
    return {
      users: null,
      userList: [],
      userSearchLoading: false };

  }componentDidMount()

  {
  }componentWillUnmount()
  {
    this.debouncedSearchUser.cancel();
  }createLockForm(

  model) {
    const { loc_id, createLocksPermissionsAction, apiCallFailureAction } = this.props;
    return api.createLockPermissions(loc_id, model).then(json => {
      createLocksPermissionsAction.success(json);
      KBPopover.close();
      return true;
    }, error => {
      createLocksPermissionsAction.failure(error);
      apiCallFailureAction(error);
    });
  }changeYMD(

  fields, index, dateField, timeField, value) {
    const lockPermission = fields.get(index) || {};
    let date = dayjs(value);
    let year = date.get('year');
    let month = date.get('month');
    let day = date.get('date');
    fields.remove(index);
    fields.insert(index, {
      ...lockPermission,
      [dateField]: value,
      [timeField]: dayjs(lockPermission[timeField]).
    clone().
    set({ year, month, date: day, second: 0, millisecond: 0 }).
      toDate() });

  }changeHM(

  fields, index, hmField, timeField, value) {
    const lockPermission = fields.get(index) || {};
    let t = value.split(',');
    fields.remove(index);
    fields.insert(index, {
      ...lockPermission,
      [hmField]: value,
      [timeField]: dayjs(lockPermission[timeField]).
    clone().
    set({ hour: t[0], minute: t[1] == '1' ? 0 : 30, second: 0, millisecond: 0 }).
      toDate() });

  }searchUser(

  searchString = '') {
    const value = typeof searchString === 'string' ? searchString.trim() : '';
    if (value) {
      const { loc_id } = this.props;
      this.setState({ userSearchLoading: true });
      api.
      getUsers({
        location_id: loc_id,
        page: 1,
        per_page: 999999,
        includes: 'space_users',
        name: value }).

      then(({ json }) => {
        const list = json.entities.users ? Object.values(json.entities.users) : [];
        this.setState({ userList: list });
      }).finally(() => {
        this.setState({ userSearchLoading: false });
      });
    } else {
      this.setState({ userList: [], userSearchLoading: false });
    }
  }renderLockPermissions(
  { fields, meta, locks, operateType, DEAL_DAY_TIME_HM, submitting, userSearchLoading, userList }) {
    var halfClass = {
      className: 'kb-form-group kb-div-c48' };
    const lock_permissions = toKBArrayField(fields);
    return lock_permissions.length > 0 &&
    lock_permissions.map((permissions, index) => {
      return (
        <div className="kb-form-container-m" key={index}>
          {operateType == 'create' ?
          <div className="kb-row kb-form-66">
              <div className="kb-form-group kb-div-48">
                <label>会员<span className="must-fill">*</span></label>
                <div>
              <Select
              showSearch
              style={{ width: '100%' }}
              // value={permissions.user_id.value}
              placeholder="输入名称搜索会员"
              notFoundContent={userSearchLoading ? <Spin size="small" /> : undefined}
              suffixIcon={null}
              filterOption={false}
              onSearch={this.debouncedSearchUser}
              onChange={value => permissions.user_id.onChange(value)}>

                {
                userList.map(item => {
                  return <Option key={item.id} value={item.id}>{item.name}</Option>;
                })}

              </Select>
              {
              permissions.user_id.touched && permissions.user_id.error && <p className="lr-error">{permissions.user_id.error}</p>}
                </div>

            </div>
          </div> :

          <div className="kb-row">
              <KBUserInput
              title="门禁名称"
              placeholder="选择门禁"
              className="kb-form-group kb-form-210 kb-form-alone"
              field={permissions.lock_id}
              isRequired={true}
              multi={false}
              users={locks}
              selectedUsers={[]} />

            </div>}

          <div className="kb-row kb-form-66">
            <KBDateInput
            type="date"
            title="开始日期"
            isRequired={true}
            className="kb-form-group kb-div-48"
            field={{ ...permissions.startYMD, onChange: () => {} }}
            onChange={data => this.changeYMD(fields, index, 'startYMD', 'start_at', data)} />

            <KBSelect
            title="开始时间"
            onChange={data => this.changeHM(fields, index, 'startHM', 'start_at', data)}
            titleClass="label-rt"
            arrayData={DEAL_DAY_TIME_HM}
            field={{ ...permissions.startHM, onChange: () => {} }}
            {...halfClass} />

          </div>
          <div className="kb-row kb-form-66">
            <KBDateInput
            type="date"
            title="结束日期"
            isRequired={true}
            className="kb-form-group kb-div-48"
            field={{ ...permissions.endYMD, onChange: () => {} }}
            onChange={data => this.changeYMD(fields, index, 'endYMD', 'end_at', data)} />

            <KBSelect
            title="结束时间"
            onChange={data => this.changeHM(fields, index, 'endHM', 'end_at', data)}
            titleClass="label-rt"
            arrayData={DEAL_DAY_TIME_HM}
            field={{ ...permissions.endHM, onChange: () => {} }}
            {...halfClass} />

          </div>
          {meta.submitFailed && meta.error ?
          <p className="lr-error">{meta.error}</p> :
          null}
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>);

    });
  }render()

  {
    const {
      handleSubmit,
      locks,
      operateType,
      DEAL_DAY_TIME_HM,
      submitting } =
    this.props;
    const { userSearchLoading, userList } = this.state;
    return (
      <form onSubmit={handleSubmit(this.createLockForm)}>
        <KBFormError error={this.props.error} />
        <header className="kb-form-header">
          <h2 className="header-title">添加门禁权限</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <FieldArray
        name="lock_permissions"
        component={this.renderLockPermissions}
        locks={locks}
        operateType={operateType}
        DEAL_DAY_TIME_HM={DEAL_DAY_TIME_HM}
        submitting={submitting}
        userSearchLoading={userSearchLoading}
        userList={userList} />
      </form>);

  }};


//

function mapStateToProps(state, props) {
  let DEAL_DAY_TIME_HM = DAY_TIME_HM(0, 24);
  return {
    DEAL_DAY_TIME_HM };

}

function mapDispatchToProps(dispatch) {
  return {
    createLocksPermissionsAction: bindActionCreators(
    lockPermissionsActions.create,
    dispatch),
    apiCallFailureAction: bindActionCreators(apiCallFailure, dispatch) };


}

const validatePermissions = Permissions => {
  const errors = {};

  if (valid.required(Permissions.user_id)) {
    errors.user_id = '请选择会员';
  }

  if (valid.required(Permissions.lock_id)) {
    errors.lock_id = '请选择门禁';
  }

  if (
  Permissions.start_at &&
  Permissions.end_at &&
  dayjs(Permissions.end_at).
  startOf('minute').
  diff(dayjs(Permissions.start_at).startOf('minute')) <= 0)
  {
    errors.endHM = '结束日期必须大于开始日期';
  }

  return errors;
};

const validate = values => {
  const errors = {};

  errors.lock_permissions = (values.lock_permissions || []).map(validatePermissions);
  const lockPermissionError = errors.lock_permissions.find(permission => {
    return permission.user_id || permission.lock_id || permission.endHM;
  });
  if (lockPermissionError) {
    errors.lock_permissions._error =
    lockPermissionError.user_id || lockPermissionError.lock_id || lockPermissionError.endHM;
  }

  return errors;
};

const formConfig = {
  form: 'MeetingForm',
  validate: validate,
  touchOnBlur: false };


LockPermissionsForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(LockPermissionsForm));

export default LockPermissionsForm;
